export interface IDealFeatureCardModalDetails {
  title: string;
  details: string[];
  badge: string;
  image: {
    x1: string;
    x2: string;
  };
}

export interface IDealFeatureCardModal {
  title: string;
  description: string;
  details: IDealFeatureCardModalDetails[];
}

export interface IDealFeatureCard {
  title: string;
  description: string;
  image: {
    x1: string;
    x2: string;
  };
  modal: IDealFeatureCardModal;
  type: EDealFeatureCardTypes;
}

export enum EDealFeatureCardTypes {
  InOffice,
  Remotely,
  InVtbBank,
  SameDayDeal,
  WithAccessibility,
  WithMortgage,
}
